import React, { useState } from "react";
import ItemResolver from "../../preview/items/ItemResolver";
import { Box, Dialog } from "@mui/material";
import DsasButton from "../../../../../components/DsasButton/DsasButton";
import { faEye } from "@fortawesome/free-regular-svg-icons";

const Preview = ({ event, directEvent }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box className='centered-wrapper'>
      {/* 🔘 Bouton d'ouverture */}
      {/* <button onClick={() => setIsOpen(true)}>Prévisualisation</button> */}
      <DsasButton label='Prévisualiser' variant='secondary' icon={faEye} onClick={() => setIsOpen(true)}></DsasButton>

      {/* Popup */}
      <Dialog onClose={() => setIsOpen(false)} open={isOpen}>
        <Box padding={3} alignItems="center" textAlign={"center"}>
            <button className="close-btn" onClick={() => setIsOpen(false)}>✖</button>
            <div style={{padding : '10px'}}>
              <ItemResolver item={event} match={directEvent} />
            </div>
        </Box>
      </Dialog>

    </Box>
  );
};

export default Preview;
